

precision highp float;
precision highp sampler2D;

uniform float opacity;
uniform sampler2D tex0;

in vec2 coord;
out vec4 fragColor;

void main() {
  vec4 c = texture(tex0, coord);

  if (c.a < 1.0 / 16.0) {
    discard;
  }

  if (opacity < 0.0001) {
    discard;
  }

  fragColor = c;
  fragColor.a *= opacity;
}
